import { render, staticRenderFns } from "./HistoricRecordChart.vue?vue&type=template&id=47417e9c"
import script from "./HistoricRecordChart.vue?vue&type=script&lang=js"
export * from "./HistoricRecordChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports